<div class="assignment-config" *ngIf="this.dataLoaded">
  <div class="config-container">
    <header class="config-header">
      <h2>Assignment Details</h2>
      <button class="help-btn" (click)="openLink('https://support.inspera.com/hc/en-us/articles/20858791561245-Assignment-Configuration-Settings-Navigation-Options')">
        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
          <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
        </svg>
        Help
      </button>
    </header>
    <form action="" [formGroup]="assignmentForm">
      <div class="form-section" *ngIf="currentUser?.Institution?.InstitutionSettings[0]?.translationAnalysisPaid && currentUser?.Institution?.InstitutionSettings[0]?.enableTranslatedLanguages">
        <div class="section-header">
          <h3>Translation Similarity</h3>
        </div>
        <div class="form-control">
          <div class="toggle-switch">
            <label class="switch-label" (click)="translatedLanguageEnabled.setValue(!translatedLanguageEnabled.value)">
              <span class="switch-button" [class.active]="translatedLanguageEnabled.value"></span>
            </label>
          </div>
          <span class="line" *ngIf="translatedLanguageEnabled.value"></span>
          <div *ngIf="translatedLanguageEnabled.value" style="width: 100%;">
            <p class="sm_title">Select languages</p>
            <div class="language-selection">
              <mat-form-field>
                <mat-select [formControl]="selectedTranslatedLanguages" multiple>
                  <mat-option *ngFor="let language of languages" [value]="language.value"
                    [disabled]="selectedTranslatedLanguages?.value?.length >= 3 && !isSelected(language.value)">
                    {{ language.text }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="selectedTranslatedLanguages?.value?.length > 0">
                  {{ selectedTranslatedLanguages?.value?.length }}/3 {{ 'new_entries.selected' | translate }}
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- <select formControlName="translatedLanguage" (change)="this.languageSelected(2)">
                <option value="0" disabled selected>Choose Language</option>
                <ng-container *ngFor="let language of this.languages">
                   <option value="{{ language.value }}" *ngIf="language.selectedDocLanguage === false">
                      {{ language.text }}
                   </option>
                </ng-container>
             </select> -->
      </div>

      <!-- Contextual Similarity -->
      <div class="form-section" *ngIf="currentUser?.Institution?.InstitutionSettings[0]?.enableContextualSimilarity">
        <div class="section-header">
          <h3>Contextual Similarity</h3>
        </div>
        <div class="form-control">
          <div class="toggle-switch">
            <label class="switch-label" (click)="assignmentForm.patchValue({contextualSimilarity: !form.contextualSimilarity.value})">
              <span class="switch-button" [class.active]="form.contextualSimilarity.value"></span>
            </label>
          </div>
          <div *ngIf="form.contextualSimilarity.value" class="threshold-input-container">
            <label>Threshold Percentage:</label>
            <div class="input-with-unit">
              <input formControlName="contextualSimilaritiesThreshold" type="number" min="50" max="100" />
              <span class="unit">%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- AI Detection -->
      <div class="form-section" *ngIf="currentUser?.Institution?.InstitutionSettings[0]?.enableAiDetection && currentUser?.Institution?.InstitutionSettings[0]?.aiDetectionPaid">
        <div class="section-header">
          <h3>{{ 'general.enable_ai_prediction' | translate }}</h3>
        </div>
        <div class="form-control">
          <div class="toggle-switch">
            <label class="switch-label" (click)="assignmentForm.patchValue({aiDetection: !form.aiDetection.value})">
              <span class="switch-button" [class.active]="form.aiDetection.value"></span>
            </label>
          </div>
        </div>
      </div>

      <!-- Metadata Analysis -->
      <div class="form-section" *ngIf="currentUser?.Institution?.InstitutionSettings[0]?.enableMetadataAnalysis">
        <div class="section-header">
          <h3>{{ 'new_entries.metadata_analysis' | translate }}</h3>
        </div>
        <div class="form-control">
          <div class="toggle-switch">
            <label class="switch-label" (click)="assignmentForm.patchValue({metadataAnalysis: !form.metadataAnalysis.value})">
              <span class="switch-button" [class.active]="form.metadataAnalysis.value"></span>
            </label>
          </div>
        </div>
      </div>

      <!-- Document Archive -->
      <div class="form-section" *ngIf="this.currentUser?.Institution?.InstitutionSettings[0]?.enableArchiveDocuments">
        <div class="section-header">
          <h3>Document archive</h3>
        </div>
        <div class="form-control">
          <div class="toggle-switch">
            <label class="switch-label" (click)="assignmentForm.patchValue({archive: !form.archive.value})">
              <span class="switch-button" [class.active]="form.archive.value"></span>
            </label>
          </div>
        </div>
      </div>

      <!-- Additional Settings -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="additional_settings_heading pointer" [ngClass]="{'rotate': additionalSettings}"
            (click)="toggleAdditionalSettings()">Additional settings</h3>
        </div>
        
        <div *ngIf="additionalSettings" class="additional-settings-container">
          
          <!-- Font Family -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>{{ 'new_entries.font_family' | translate }}</h4>
            </div>
            <select formControlName="fontFamily">
              <option selected disabled value="">{{ 'new_entries.select_font_family' | translate }}</option>
              <ng-container *ngFor="let fontFamily of this.fontFamilies">
                <option value="{{ fontFamily.value }}">{{ fontFamily.name }}</option>
              </ng-container>
            </select>
          </div>

          <!-- Late Submissions -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>{{ 'general.late_submissions' | translate }}</h4>
            </div>
            <div class="setting-control">
              <div class="toggle-switch">
                <label class="switch-label" (click)="toggleLateSubmissions()">
                  <span class="switch-button" [class.active]="form.lateSubmissions.value"></span>
                </label>
              </div>
              <input *ngIf="form.lateSubmissions.value" 
                     formControlName="lateSubmissionsDate" 
                     [min]="assignmentData?.endDate" 
                     owlDateTime owlDateTimeTrigger
                     placeholder="Select date and time" 
                     class="date-input" />
            </div>
            <div *ngIf="form.lateSubmissions.value && (form.lateSubmissionsDate.value == '' || form.lateSubmissionsDate.value == null)" 
                 class="invalid">
              {{ 'report.late_submissions_date_is_required' | translate }}*
            </div>
          </div>

          <!-- Resubmissions -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>{{ 'general.resubmissions' | translate}}</h4>
            </div>
            <div class="setting-control">
              <div class="toggle-switch">
                <label class="switch-label" (click)="assignmentForm.patchValue({reSubmissions: !form.reSubmissions.value})">
                  <span class="switch-button" [class.active]="form.reSubmissions.value"></span>
                </label>
              </div>
              <div *ngIf="form.reSubmissions.value" class="number-input-group">
                <label>{{ 'app.no_of_ressubmissions' | translate }}</label>
                <input formControlName="nrReSubmissions" type="number" min="1" class="number-input"
                  oninput="this.value =!!this.value && Math.abs(this.value) >= 1 ? Math.abs(this.value) : null" />
              </div>
            </div>
            <div *ngIf="form.reSubmissions.value && (form.nrReSubmissions.value == '' || form.nrReSubmissions.value == null)" 
                 class="invalid">
              {{ 'app.no_of_resubmissions_is_required' | translate }}*
            </div>
          </div>

          <!-- Source Threshold -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>{{ 'general.excluded_source_criteria' | translate }}</h4>
            </div>
            <div class="input-with-unit">
              <input formControlName="source_percentage_threshold" type="number"
                [value]="currentUser?.Institution?.InstitutionSettings[0]?.source_percentage_threshold" min="0" max="100" />
              <span class="unit">%</span>
            </div>
          </div>

          <!-- Word Limit -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>{{ 'general.submission_word_limit' | translate }}</h4>
            </div>
            <input formControlName="submission_word_limit" type="number" [value]="settings?.submission_word_limit" min="100" />
          </div>

          <!-- Exclude Citations -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>{{ 'general.exclude_citations' | translate }}</h4>
            </div>
            <div class="setting-control">
              <div class="toggle-switch">
                <label class="switch-label" (click)="assignmentForm.patchValue({exclude_citations: !form.exclude_citations.value})">
                  <span class="switch-button" [class.active]="form.exclude_citations.value"></span>
                </label>
              </div>
            </div>
          </div>

          <!-- Similarity Thresholds -->
          <div class="setting-item" *ngIf="currentUser?.Institution?.InstitutionSettings[0]?.enableSimilarityThresholdsEdit">
            <div class="setting-header">
              <h4>Similarity Thresholds</h4>
            </div>
            <div class="thresholds-grid">
              <div class="threshold-group">
                <label>Altered Text Threshold:</label>
                <div class="input-with-unit">
                  <input formControlName="alteredTextThreshold" type="number" min="40" max="90" />
                  <span class="unit">%</span>
                </div>
              </div>
              <div class="threshold-group">
                <label>Exact Match Threshold:</label>
                <div class="input-with-unit">
                  <input formControlName="exactMatchThreshold" type="number" min="60" max="100" />
                  <span class="unit">%</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Include URLs -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>Include URLs</h4>
            </div>
            <div class="textarea-container">
              <mat-chip-list #chipList>
                <mat-chip
                  *ngFor="let control of assignmentForm.controls.sources.get('includeSources').controls; let i = index"
                  [selectable]="true" [removable]="true" (removed)="removeUrl(i, 'include')" class="trim-chip">
                  {{ control.value }}
                  <mat-icon matChipRemove>X</mat-icon>
                </mat-chip>
                <input placeholder="New URL..." [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addUrl($event, 'include')" class="chip-input" />
              </mat-chip-list>
            </div>
          </div>

          <!-- Exclude URLs -->
          <div class="setting-item">
            <div class="setting-header">
              <h4>Exclude URLs</h4>
            </div>
            <div class="textarea-container">
              <mat-chip-list #chipList>
                <mat-chip
                  *ngFor="let control of assignmentForm.controls.sources.get('excludeSources').controls; let i = index"
                  [selectable]="true" [removable]="true" (removed)="removeUrl(i, 'exclude')" class="trim-chip">
                  {{ control.value }}
                  <mat-icon matChipRemove>X</mat-icon>
                </mat-chip>
                <input placeholder="New URL..." [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addUrl($event, 'exclude')" class="chip-input" />
              </mat-chip-list>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>